<template>
  <div class="view-financial-data">
    <page-header
      title="Dados Financeiros"
      subtitle="Cadastre contas bancárias para receber suas comissões."
    />
    <page-container>
      <div
        class="p-3 border rounded border-information-400 mb-7 bg-information-024"
      >
        <div class="d-flex gap-3">
          <bp-icon icon="fa fa-info-circle" class="text-information-500" />
          <span class="functional-1 text-information-800">
            Sua conta está habilitada para solicitar saque em conta bancária
            {{ accountType }}. Caso deseje solicitar saque em uma conta bancária
            {{ oppositeAccountType }}, altere a Natureza do Negócio em
            <router-link :to="{ name: 'user-personal-data' }" class="link">
              Dados Pessoais
            </router-link>
          </span>
        </div>
      </div>
      <bp-table-header
        class="mb-7"
        :total="bankAccounts.length"
        @refresh="dispatch"
      >
        <template #buttons>
          <bp-button
            size="md"
            label="Adicionar"
            icon="fa fa-plus"
            @click="modal = true"
          />
        </template>
      </bp-table-header>

      <div v-if="loading" class="text-center">
        <b-spinner variant="primary" />
      </div>

      <bp-data-table v-else :data="bankAccounts" :columns="columns" />

      <responsive-modal
        v-model="modal"
        size="lg"
        title="Nova conta"
        description="Insira os dados da sua conta"
      >
        <account-modal @close="modal = false" @refresh="dispatch" />
      </responsive-modal>
    </page-container>
  </div>
</template>
<script>
import AccountModal from "@/components/user/FinancialData/AccountModal.vue";
import { isValidCPF } from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  components: {
    AccountModal
  },
  data() {
    return {
      loading: false,
      modal: false
    };
  },
  computed: {
    ...mapState("financial", ["bankAccounts", "banksList"]),
    ...mapState("user", ["user"]),
    accountType() {
      return !this.user.company.document ||
        isValidCPF(this.user.company.document)
        ? "PF"
        : "PJ";
    },
    oppositeAccountType() {
      return this.accountType == "PJ" ? "PF" : "PJ";
    },
    columns() {
      return [
        {
          name: "Titular",
          field: "owner_account"
        },
        {
          name: "Banco",
          field: "bank",
          transform: this.getBankName
        },
        {
          name: "Agência",
          field: "agency",
          transform: (_, item) => `${item.agency}-${item.agency_vd}`
        },
        {
          name: "Conta",
          field: "number_account",
          transform: (_, item) =>
            `${item.number_account}-${item.number_account_vd}`
        },
        {
          name: "Tipo de Conta",
          field: "type_account",
          transform: v => (v == 1 ? "Conta Corrente" : "Conta Poupança")
        },
        {
          name: "Natureza",
          field: "type",
          transform: this.getDescType
        },
        {
          name: "Status",
          field: "status",
          transform: this.formatStatus,
          color: v =>
            ({
              approved: "green",
              deny: "negative",
              in_analysis: "alert"
            }[v]),
          type: "tag"
        }
        // {
        //   name: "",
        //   type: "menu",
        //   actions: []
        // }
      ];
    }
  },
  methods: {
    getBankName(id) {
      return this.banksList.find(item => item.id == id)?.long_name;
    },
    getDescType(val) {
      return val == "pf" ? "Pessoa Física" : "Pessoa Jurídica";
    },
    formatStatus(val) {
      const options = {
        in_analysis: "Em análise",
        approved: "Aprovado",
        deny: "Negado",
        in_review: "Em revisão",
        reject: "Rejeitada"
      };
      return options[val] || val;
    },

    dispatch() {
      this.loading = true;
      this.$store
        .dispatch("financial/getBankAccounts", { limit: 100 })
        .catch(() => {
          this.$message.error("Erro ao carregar contas bancárias");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.dispatch();
    this.$store.dispatch("financial/getBanksList");
  }
};
</script>
<style lang="scss">
.view-financial-data {
  .link {
    color: $information-500 !important;
    text-decoration: underline !important;
  }
}
</style>
